export default __webpack_public_path__ + "static/media/YAS0780.34I-35632_-25379_0.1f29e050.jpg";